export default "__VITE_ASSET__qFcp0$By__"